import { useMemo } from "react";
import ContentLoader from "react-content-loader";

const ImageLoader = ({ size, x, y, rx, ry, width, height }) => {
  const sizeObject = useMemo(() => {
    return {
      width: "100%",
      height: "100%",
    };
  }, [size]);

  return (
    <rect
      x={x ?? 0}
      y={y ?? 0}
      rx={rx ?? sizeObject.rx}
      ry={ry ?? sizeObject.ry}
      width={width ?? sizeObject.width}
      height={height ?? sizeObject.height}
    />
  );
};

const ImageContentLoader = () => (
  <ContentLoader
    speed="2"
    backgroundColor="#fdfdfd"
    foregroundColor="#ecf4ef"
    style={{ width: "100%", minWidth: "17.6rem", height: "100%" }}
  >
    <ImageLoader />
  </ContentLoader>
);

export default ImageContentLoader;
